module.exports = __webpack_public_path__ + "img/Group 280.fe84ae04.svg";